import { render } from "./industry-modal.vue?vue&type=template&id=6cf65f73"
import script from "./industry-modal.vue?vue&type=script&lang=js"
export * from "./industry-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__